import { useEffect, useRef, useState } from 'preact/hooks'

/**
 * Whether a web's Re-run panel (ORB-1065) is open, for the header's button and the panel under it. It closes when
 * the page moves to another web (the new re-run included), and when Re-run stops applying to this one, as when it
 * is switched to BigMarker.
 */
export function useRerunPanel(webId: string, available: boolean) {
    const [open, setOpen] = useState(false)
    const buttonRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {
        setOpen(false)
    }, [webId, available])

    return {
        // Gated here too, so the panel is gone on the very render Re-run stops applying, not one render later.
        open: open && available,
        toggle: () => setOpen(value => !value),
        close: () => {
            setOpen(false)
            buttonRef.current?.focus()
        },
        buttonRef,
    }
}
